// Date display helpers for property-scoped dates.
//
// Bill / measurement / invoice dates are stored as canonical `YYYY-MM-DD`
// strings with no timezone (see specs/001-pdf-bill-parsing.md). Rendering them
// with `new Date('YYYY-MM-DD')` parses as UTC midnight, which shifts to the
// previous calendar day for any viewer west of UTC. Format calendar dates in
// UTC to preserve their day; only actual timestamps use the property's zone.
//
// The stored strings are NOT rewritten; this is presentation only.

export const DEFAULT_PROPERTY_TIME_ZONE = 'America/Los_Angeles';

/**
 * Preserve the calendar day of canonical `YYYY-MM-DD` strings in every zone.
 * Legacy timestamps use the property timezone (Pacific when unset).
 * Return the raw input unchanged if it cannot be parsed.
 */
export function formatPropertyDate(
  date: string,
  timeZone: string | null | undefined = DEFAULT_PROPERTY_TIME_ZONE,
  options: Intl.DateTimeFormatOptions = { year: 'numeric', month: 'long', day: 'numeric' },
): string {
  const tz = timeZone || DEFAULT_PROPERTY_TIME_ZONE;
  const isCalendarDate = /^\d{4}-\d{2}-\d{2}$/.test(date);
  const d = new Date(date);
  if (Number.isNaN(d.getTime())) return date;
  try {
    return new Intl.DateTimeFormat('en-US', {
      ...options, timeZone: isCalendarDate ? 'UTC' : tz,
    }).format(d);
  } catch {
    return new Intl.DateTimeFormat('en-US', options).format(d);
  }
}
